"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computedQuestionnaireAnswers = computedQuestionnaireAnswers;
const lodash_1 = __importDefault(require("lodash"));
const evaluateConditions_1 = require("../condition-engine/evaluateConditions");
const queries_1 = require("../condition-engine/queries");
const operators_1 = require("../types/carrierQuestionnaire/conditions/operators");
const ExpandedRepetitionsVisitor_1 = require("./expandedContext/ExpandedRepetitionsVisitor");
const filterVisibleAnswers_1 = require("./nodeEvaluation/visibleIf/filterVisibleAnswers");
class ComputedAnswersVisitor extends ExpandedRepetitionsVisitor_1.ExpandedRepetitionsVisitor {
    visibilityDependencyMap;
    changedNodeInstances = [];
    timezone;
    answersResolver; // This is shadowing the base class property because it requires more permission here.
    currentDateOverride;
    constructor(answersResolver, visibilityDependencyMap, timezone, currentDateOverride) {
        super(answersResolver);
        this.answersResolver = answersResolver;
        this.visibilityDependencyMap = visibilityDependencyMap;
        this.timezone = timezone;
        this.currentDateOverride = currentDateOverride;
    }
    setComputedAnswers(questionnaire) {
        this.visitQuestionnaire(questionnaire);
        return;
    }
    getChangedNodeInstances() {
        return lodash_1.default.uniqWith(this.changedNodeInstances, lodash_1.default.isEqual);
    }
    visitField(field) {
        const { blueprintId, computedValue } = field;
        if (!computedValue) {
            return;
        }
        const scopes = this.repeatedInstanceIdentifiers();
        if (!this.isFieldVisible(field, scopes.byNodeId)) {
            return;
        }
        const computedFieldValue = (0, queries_1.evaluateQuery)(computedValue, this.answersResolver, scopes.byNodeId, this.timezone, {}, this.currentDateOverride);
        const currentAnswer = this.answersResolver.getAnswer(blueprintId, scopes.byBlueprintId);
        if (computedFieldValue === currentAnswer) {
            return;
        }
        this.answersResolver.setAnswer(computedFieldValue, blueprintId, scopes.byBlueprintId);
        this.changedNodeInstances.push({
            byBlueprintId: {
                blueprintId: blueprintId,
                blueprintIdScope: scopes.byBlueprintId,
            },
            byNodeId: {
                nodeId: field.nodeId,
                nodeIdScope: scopes.byNodeId,
            },
        });
    }
    isFieldVisible(field, scope) {
        let fieldVisibilityConditions = undefined;
        if (field.nodeId) {
            fieldVisibilityConditions = this.visibilityDependencyMap.getVisibilityConditions(field.nodeId);
        }
        let visibilityConditions = undefined;
        if (fieldVisibilityConditions) {
            visibilityConditions = fieldVisibilityConditions?.field;
        }
        const isFieldVisible = !visibilityConditions ||
            (0, evaluateConditions_1.evaluateConditions)({ conditions: visibilityConditions, operator: operators_1.BooleanOperators.or }, this.answersResolver, scope, this.timezone, this.currentDateOverride).isValid;
        return isFieldVisible;
    }
}
function computedQuestionnaireAnswers(questionnaire, answersResolver, dependencyMap, timezone, currentDateOverride) {
    const computedAnswersVisitor = new ComputedAnswersVisitor(answersResolver, dependencyMap, timezone, currentDateOverride);
    computedAnswersVisitor.setComputedAnswers(questionnaire);
    // Setting computed answers may affect the visibility of other answers.
    for (const nodeInstance of computedAnswersVisitor.getChangedNodeInstances()) {
        if (nodeInstance.byNodeId.nodeId) {
            (0, filterVisibleAnswers_1.filterVisibleAnswers)(nodeInstance.byNodeId.nodeId, dependencyMap, answersResolver, nodeInstance.byNodeId.nodeIdScope, timezone, currentDateOverride);
        }
    }
}
